import React from "react";
import { Link } from "react-router-dom";
import { Clock, AlertCircle } from "lucide-react";

function Informes() {
  const cards = [
    {
      icon: <Clock size={28} color="var(--clr-accent)" />,
      title: "Horas trabajadas",
      description: "Consulta y exporta el registro detallado de horas trabajadas por empleado en el período que necesites.",
      to: "/admin/informes/listadohoras",
      bg: "var(--clr-accent-bg)",
    },
    // {
    //   icon: <AlertCircle size={28} color="#F59E0B" />,
    //   title: "Incidencias",
    //   description: "Filtra y exporta el listado de incidencias por empleado, tipo y estado en formato PDF.",
    //   to: "/admin/informes/listadoincidencias",
    //   bg: "#FFFBEB",
    // },
  ];

  return (
    <div>
      <h1 className="tn-page-title">Informes</h1>
      <p className="tn-page-sub">Genera y exporta informes en PDF para tu empresa</p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(min(100%,360px),1fr))", gap: 16, marginTop: 8 }}>
        {cards.map((card) => (
          <div key={card.to} className="tn-card tn-card--hover" style={{ padding: 24 }}>
            <div style={{ width: 52, height: 52, borderRadius: 12, background: card.bg, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
              {card.icon}
            </div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: "var(--clr-text)", marginBottom: 8 }}>{card.title}</h3>
            <p style={{ fontSize: 13.5, color: "var(--clr-muted)", marginBottom: 20, lineHeight: 1.5 }}>{card.description}</p>
            <Link to={card.to} className="tn-btn tn-btn--primary" style={{ display: "inline-flex", textDecoration: "none"}}>
              Ver informe
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Informes;